import { render, staticRenderFns } from "./DeliveryDetail.vue?vue&type=template&id=b7434a26&scoped=true"
import script from "./DeliveryDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryDetail.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDetail.vue?vue&type=style&index=0&id=b7434a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7434a26",
  null
  
)

export default component.exports